import React, { useEffect, FC } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import ConditionalRedirecter from 'App/ConditionalRedirecter'
import { ACCOUNT_ROUTES } from 'App/constants'
import appSelectors from 'App/duck/selectors'

import { FILTER_NAME } from '../../duck/constants'
import {
  operationFetchOrders,
  operationFetchKlarnaProfile,
  operationFetchMonthlyInvoices,
} from '../../duck/operations'
import selectors from '../../duck/selectors'
import HMPayComponent from './HMPayOverview.component'

export const HMPay: FC = () => {
  const dispatch = useDispatch()
  const shouldFetchOrders = useSelector((state) =>
    selectors.getShouldFetchOrdersForFilter(FILTER_NAME.ALL, state),
  )
  const shouldFetchToDoOrders = useSelector((state) =>
    selectors.getShouldFetchOrdersForFilter(FILTER_NAME.TO_DO, state),
  )
  const isPayLaterActivatedForUser = !useSelector(appSelectors.getIsPayLaterActivatedForUser)
  const isPayLaterActionEnabled = useSelector(appSelectors.getIsPayLaterActivationEnabled)
  const shouldGoToOptInPage = isPayLaterActivatedForUser && isPayLaterActionEnabled

  const shouldFetchKlarnaProfile = useSelector(selectors.getShouldFetchKlarnaProfile)
  const shouldFetchMonthlyInvoices = useSelector(selectors.getShouldFetchMonthlyInvoices)

  const fetchOrders = (filterName?: string): any => dispatch(operationFetchOrders(filterName))
  const fetchKlarnaProfile = (): void => {
    dispatch(operationFetchKlarnaProfile())
  }
  const fetchMonthlyInvoices = (): void => {
    dispatch(operationFetchMonthlyInvoices())
  }

  useEffect(() => {
    if (shouldFetchKlarnaProfile) {
      fetchKlarnaProfile()
    }
  }, [shouldFetchKlarnaProfile])

  useEffect(() => {
    if (shouldFetchOrders) {
      fetchOrders()
    }
  }, [shouldFetchOrders])

  useEffect(() => {
    if (shouldFetchToDoOrders) {
      fetchOrders(FILTER_NAME.TO_DO)
    }
  }, [shouldFetchToDoOrders])

  useEffect(() => {
    if (shouldFetchMonthlyInvoices) {
      fetchMonthlyInvoices()
    }
  }, [shouldFetchMonthlyInvoices])

  return (
    <ConditionalRedirecter
      shouldRedirect={shouldGoToOptInPage}
      fallbackRoute={ACCOUNT_ROUTES.PayLaterStoreActivationInfo.path}
    >
      <HMPayComponent />
    </ConditionalRedirecter>
  )
}

export default HMPay
